import { PRINT_HIDE_ACTIONS, RESET_SHOW_ACTIONS } from "./types";
export const printHideAction = (resolve) => ({
    type: PRINT_HIDE_ACTIONS,
    resolveHandler: resolve,
});
export const resetShowAction = () => ({
    type: RESET_SHOW_ACTIONS,
    resolveHandler: () => undefined,
});
